import React, { useContext } from 'react';
import { number, string, bool } from 'prop-types';
import { Card, CardActions, Button } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { dataModel } from '../../dataModels/dataModel';
import { QuotesProvider } from '../../context/QuotesContext';
import { defaultCardContentProps, showBelowSmBreakpoint } from '../../constants/responsiveClassNames';
import QuotesHeader from './QuotesHeader';
import QuotesTabsView from './QuotesTabsView';
import QuotesNoTabsView from './QuotesNoTabsView';
import QuotesNullView from './QuotesNullView/QuotesNullView';
import QuotesLoading from './QuotesLoading';
import QuotesError from './QuotesError';
import { useQuoteContext } from '../../hooks/useQuoteContext';
import { triggerAnalyticsCustomEvent } from '../../utils/analyticsEvents';

const QuotesActions = () => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const viewAllQuotesClick = () => {
    triggerAnalyticsCustomEvent('quotes.stash-click', {
      component: 'view all'
    });
  };
  return isMobile ? (
    <div>
      <CardActions>
        <Button onClick={viewAllQuotesClick} fullWidth href="/quote/list">View All Quotes</Button>
      </CardActions>
    </div>
  ) : null;
};

QuotesActions.propTypes = {};
QuotesActions.defaultProps = {};

const QuotesContent = () => {
  const {
    loading,
    error,
    hasQuotes,
    showTabs,
  } = useQuoteContext();

  // Loading skeleton
  if (loading) {
    return <QuotesLoading />;
  }

  // Error state
  if (error) {
    return <QuotesError />;
  }

  if (!hasQuotes) {
    return <QuotesNullView />;
  }

  return (
    <Card
      data-component="Quotes"
      data-testid="quotes-container"
      className="sui-h-full sui-w-full"
      CardContentProps={{ className: classNames(defaultCardContentProps, 'sui-h-full') }}
    >
      <div className="sui-@container sui-h-full" id="quotes">
        <div className="sui-flex sui-flex-col sui-h-full">
          <QuotesHeader />
          <div
            className="sui-flex sui-flex-col sui-justify-between sui-grow"
          >
            {showTabs ? (
              <QuotesTabsView />
            ) : (
              <QuotesNoTabsView />
            )}
            <QuotesActions />
          </div>
        </div>
      </div>
    </Card>
  );
};

QuotesContent.propTypes = {};

QuotesContent.defaultProps = {};

const Quotes = ({ maxListSize, componentId }) => {
  return (
    <QuotesProvider
      maxListSize={maxListSize}
      componentId={componentId}
    >
      <QuotesContent />
    </QuotesProvider>
  );
};

Quotes.propTypes = {
  maxListSize: number,
  componentId: string,
};

Quotes.defaultProps = {
  maxListSize: 3,
  componentId: '',
};

Quotes.displayName = 'Quotes';
Quotes.dataModel = dataModel;

export { Quotes, QuotesContent };
